import env from '../../utils/env';
import request from './request';

export const getAddresses = () => {
  return request(`${env.user}/users/self/addresses`, 'GET', {
    'Content-Type': 'application/json',
    'FFF-Auth': 'V1.1',
  });
};

export const getAddress = (id: string) => {
  return request(`${env.user}/users/self/addresses/${id}`, 'GET', {
    'Content-Type': 'application/json',
    'FFF-Auth': 'V1.1',
  });
};

export const updateAddress = (payload: Record<string, string>, id: string) => {
  return request(
    `${env.user}/users/self/addresses/${id}`,
    'PUT',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(payload),
  );
};

export const addAddress = (payload: Record<string, string>) => {
  return request(
    `${env.user}/users/self/addresses`,
    'POST',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(payload),
  );
};

export const removeAddress = (addressId: string) => {
  return request(`${env.user}/users/self/addresses/${addressId}`, 'DELETE', {
    'Content-Type': 'application/json',
    'FFF-Auth': 'V1.1',
  });
};

export const verifyAddress = (payload: Record<string, string>) => {
  return request(
    `${env.growth}/location/verify-address`,
    'POST',
    {
      'Content-Type': 'application/json',
      'FFF-Auth': 'V1.1',
    },
    JSON.stringify(payload),
  );
};
